export const getHourPrice = (modelPrice: number, withoutFloating = false) => {
  const price = +modelPrice;
  if (withoutFloating && price % 1 === 0) {
    return `$${price}`;
  }
  return `$${price >= 100 ? price : price.toFixed(2)}`;
};
